<template>
  <v-card>
    <v-card-title>
      Tissue Expiry
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="getDaskboard"
      fixed-header
      height="300"
    >
      <template #[`item.exp_date`]="{ item }">
        <pre>{{moment(item.exp_date).format('DD-MM-YYYY HH:mm')}}</pre>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import daskboardserice from '@/service/Dashboard.service'
import moment from 'moment'

export default {
  data() {
    const statusColor = {
      /* eslint-disable key-spacing */
      Current: 'primary',
      Professional: 'success',
      Rejected: 'error',
      Resigned: 'warning',
      Applied: 'info',
      /* eslint-enable key-spacing */
    }

    return {
      moment,
      headers: [
        { text: 'Tissue ID', value: 'tissue_id' },
        { text: 'Storage Medium', value: 'storage_medium' },
        { text: 'Expiry date', value: 'exp_date' },
  
      ],
      getDaskboard:[],
      status: {
        1: 'Current',
        2: 'Professional',
        3: 'Rejected',
        4: 'Resigned',
        5: 'Applied',
      },
      statusColor,

      
    }
  },
  watch: {
    options: {
      handler() {
        this.ViewDaskBoard()
      },
      deep: true,
    },
  },
  async mounted() {
    this.ViewDaskBoard()
  },
  methods:{
    async ViewDaskBoard(){
      const service = new daskboardserice()
      let response = await service.getDaskboard()
       if (response) {
       this.getDaskboard = response.Tissue_Information
        // console.log("Hello Dataaaaaaa",this.getDaskboard)
        this.totallist = this.getDaskboard.length
    
      } else {
        this.getDaskboard = []
        this.totallist = 0
      }
    },
  }
}
</script>
